/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  HostListener,
  OnDestroy,
  ViewChild,
  TemplateRef,
  SimpleChanges,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import {
  RemoteControlService,
  RemoteControlEventArgs,
  DualScreenConfiguredEventArgs,
} from 'xsmodules/remote-control/services/remote-control.service';
import {
  TabSelectorState,
  RemoteControlTabService,
  RcTabIndexes,
} from 'xsmodules/remote-control/services/rc-tab.service';
import {
  RemoteControlAnnotationsService,
  AnnotationStatus,
} from 'xsmodules/remote-control/services/annotations.service';
import { getWin32ErrorMessage } from '../../../remote-control-ng';
import { Toast, ToastTypeIndex } from 'xsshared/components/toast/toast.component';
import { RemoteControlSessionService } from 'xsmodules/remote-control/services/session.service';
import {
  RemoteControlVideoRecordingService,
  VideoRecordingStatus,
} from 'xsmodules/remote-control/services/video-recording.service';
import { TunnelService } from '../../services/tunnel.service';
import { Subscription, SubscriptionLike } from 'rxjs';
import { first } from 'rxjs/operators';
// import { PromptDialogComponent } from 'src/app/ng-app/shared/components/prompt-dialog/prompt-dialog.component';
import { FileManagerService } from 'xsmodules/remote-control/services/file-manager.service';
import {
  DeviceLogRequestStatus,
  IDeviceLogRequestStatusChange,
  RcLogsService,
} from 'xsmodules/remote-control/services/rc-logs.service';
import { XsI18nPipe } from '@nx-fe/pipes';
import {
  AppSettingsService,
  AuthorizationService,
  DEVICE_OS_FAMILY,
  FeatureToggleService,
  GlobalEventBusService,
  GroupContextService,
  hd,
  IDeviceModel,
} from '@nx-fe/services';
import { GlobalEvents } from 'app/core/global-event-constants';
import { SnapshotService } from 'xsmodules/ticket/services/snapshot.service';
import { WorkPanelBarItem } from 'xsmodules/ticket/components/work-panel/models/work-panel-bar-items';
import { WorkPanelManagerService, WorkPanelType } from 'xsmodules/remote-control/services/work-panel-manager.service';
import { IWorkPanelInformation } from 'xsmodules/ticket/components/work-panel/work-panel-rc2.models';
import { IWorkPanelWindow, WorkPanelService } from 'xsmodules/remote-control/services/work-panel.service';
import { ISnapshotInformation } from 'xsmodules/ticket/components/snapshot/snapshot/snapshot.models';
import { RemoteControlCanvasComponent } from 'xsmodules/remote-control/remote-control-view/remote-control-canvas/remote-control-canvas.component';
import { BroadcastChannels, BroadcastService } from 'app/utils/broadcastService';
import { SotiPopupTrigger } from '@soti/popup';
import { DeviceScale, IMonitorInfo } from '../../../remote-control-ng/definitions';
import { GetSysInfoMessage } from 'app/modules/remote-control-ng/messages/pocket-com';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';
import { RcDeviceService } from '../../services/rc-device-service';
import {
  DeviceStateRegistryService,
  RecordingState,
  RemoteControlDeviceState,
} from 'app/modules/remote-control/services/device-state-registry.service';
import { DeviceContext } from 'app/modules/remote-control-ng/context/deviceContext';
import { VisualSelectionInfo } from '../multi-display-selection/multi-display-selection-view/multi-display-selection-view.component';

@Component({
  selector: 'app-rc-view-v2',
  templateUrl: './rc-view-v2.component.html',
  styleUrls: ['./rc-view-v2.component.scss'],
})
export class RcViewV2Component implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  public get isAnnotating(): boolean {
    return this.rcAnnotationService.currentState.isAnnotating;
  }

  public get isAnnotationPendingAccept(): boolean {
    return this.rcAnnotationService.currentState.isPendingAccept;
  }

  public get isAnnotationEnabled(): boolean {
    return this.rcAnnotationService.isAnnotationEnabled && this.isLicenceActive && this.isAdminOrTechnician();
  }

  public get isAnnotationAllowed(): boolean {
    return this.deviceStateRegistry.hasPermission(this.rcState, hd.RemoteControlPermissions.RemoteControlInput);
  }

  public get showAnnotationToolbar(): boolean {
    return this.isTabSelected(RcTabIndexes.remoteControl) && !this.rcHasError() && this.isLicenceActive;
  }

  public get isVideoRecordingEnabled(): boolean {
    return (this.isAttachmentEnabled || this.isStandaloneRC()) && this.isLicenceActive && this.isAdminOrTechnician();
  }

  public get isScreenshotEnabled(): boolean {
    return this.isAttachmentEnabled || this.isStandaloneRC();
  }

  public get isHorizontalScrollbarEnable(): boolean {
    return $('.home-ticket-view-restricted').width() > $(window).width();
  }

  public get isAnnotationBarHidden(): boolean {
    return $('.home-ticket-view-restricted').width() > 0;
  }

  public get isDualScreenPopupOpen(): boolean {
    return this.dualScreenPopupOpened;
  }

  public get isDarkMode(): boolean {
    return localStorage.getItem('XSightTheme') === 'darkMode';
  }

  private supportsDualScreen = false;

  private dualScreenPopupOpened = false;

  constructor(
    private remoteControlService: RemoteControlService,
    private deviceStateRegistry: DeviceStateRegistryService,
    private snapshotService: SnapshotService,
    private remoteControlSessionService: RemoteControlSessionService,
    private saI18nPipe: XsI18nPipe,
    private remoteControlTabService: RemoteControlTabService,
    public featureToggleService: FeatureToggleService,
    private rcAnnotationService: RemoteControlAnnotationsService,
    private globalEventBusService: GlobalEventBusService,
    private authorizationService: AuthorizationService,
    private workPanelManagerService: WorkPanelManagerService,
    private tunnelService: TunnelService,
    private groupContextService: GroupContextService,
    private fileManagerService: FileManagerService,
    private rcLogsService: RcLogsService,
    private videoRecordingService: RemoteControlVideoRecordingService,
    private deviceService: RcDeviceService,
    private workPanelService: WorkPanelService
  ) {}

  @Input() popOut = false;
  @Input() ticketPagePanelsCount: number;
  @Input() rcState: RemoteControlDeviceState;
  @Input() standAlone: boolean;
  @Input() isLicenceActive: boolean;
  @Input() isAgentVideoRecording = false; // TODO: more logic needs to be initialized
  @Input() disableSplash = false;
  @Input() isAttachmentEnabled: boolean;
  @Input() currentWorkPanelKey: string;
  @Input() snapshotRefreshInProgress: boolean;
  @Output() attachScreenshot = new EventEmitter<void>();
  @Output() menuBarItems = new EventEmitter<WorkPanelBarItem[]>();
  @Output() actionBarRefEvent = new EventEmitter<TemplateRef<any>>();
  @Output() titleBarRefEvent = new EventEmitter<TemplateRef<any>>(true);
  @Output() setToastEvent = new EventEmitter<Toast>();
  @Output() restartStandaloneRc = new EventEmitter<void>();

  @ViewChild('actionBar', { static: false }) public actionBarRef: TemplateRef<any>;
  @ViewChild('titleBar', { static: false }) public titleBar: TemplateRef<any>;
  @ViewChild('actionBarLegacyDeviceInfo', { static: false }) public actionBarLegacyDeviceInfoRef: TemplateRef<any>;
  @ViewChild(SotiPopupTrigger, { static: false }) multiDisplayPopupTrigger: SotiPopupTrigger;

  private headertokenSub: SubscriptionLike;

  // For older versions user has access to both ShellTerminal/WebConsole without any restrictions
  public toast: Toast = null;
  public rcMenuBarItems: WorkPanelBarItem[];
  public showFileManagerButtonsToggle: boolean;

  private _currentTabTitle: string;
  private tabSelectorState: TabSelectorState;
  private _showDeviceButtonsToggle: boolean;
  private readonly deviceLogRequestStatusChangedBroadcast: BroadcastService<IDeviceLogRequestStatusChange> =
    new BroadcastService(BroadcastChannels.onDeviceLogRequestStatusChanged);
  private readonly videoRecordingStatusChanged: BroadcastService<VideoRecordingStatus> = new BroadcastService(
    BroadcastChannels.onVideoRecordingStatusChanged
  );
  private readonly annotationStatusChanged: BroadcastService<AnnotationStatus> = new BroadcastService(
    BroadcastChannels.onAnnotationStatusChanged
  );
  private readonly nonSnapshotTabSelected: BroadcastService<void> = new BroadcastService(
    BroadcastChannels.onSnapshotViewVisibilityChanged
  );
  private readonly popoutRemoteControlStart: BroadcastService<IDeviceModel> = new BroadcastService<IDeviceModel>(
    BroadcastChannels.onPopoutRemoteControlStart
  );
  private openRcWorkPanelSub: Subscription;
  private openLiveSnapshotSub: Subscription;
  private multiScreenSub: Subscription;
  private windowsDisplayChangedSub: Subscription;

  // V2 CODE
  // ==============================================================================================
  @ViewChild('canvasOuter', { static: false }) canvasOuter: ElementRef;
  @ViewChild('videoOuter', { static: false }) videoOuter: ElementRef;
  @ViewChild(RemoteControlCanvasComponent, { static: false }) canvasComponent: RemoteControlCanvasComponent;

  @HostListener('document:rcFirstScreenLoaded', ['$event'])
  onRcFirstScreenLoaded() {
    this.rcFirstScreenLoaded();
  }

  ngOnInit() {
    this.buildRcMenuBarItems();
    this.updateCanvasZIndex(false);
    this.deviceLogRequestStatusChangedBroadcast.onMessage = this.handleDeviceLogsDownloadStatusChange;
    this.videoRecordingStatusChanged.onMessage = this.handleRecordingStatus;
    this.annotationStatusChanged.onMessage = this.handleAnnotationStatus;

    if (this.standAlone) {
      this.remoteControlService.setVideoDownloadReadyCallback(this.videoRecordingService.videoDownloadReady);
    }

    this.openRcWorkPanelSub = this.globalEventBusService.register(
      GlobalEvents.openRcWorkPanel,
      (result: IWorkPanelInformation) => {
        if (this.tabSelectorState) {
          this.updateTransformationHandler(this.tabSelectorState.selectedTab);
        }
      }
    );

    this.openLiveSnapshotSub = this.globalEventBusService.register(
      GlobalEvents.openLiveSnapshot,
      (result: ISnapshotInformation) => {
        if (result && this.tabSelectorState) {
          this.tabSelectorState.resetAll();
        }
      }
    );

    this.isVideoStreamingSupported = undefined;
    this.remoteControlService.RemoteControlStarted.subscribe((status: RemoteControlEventArgs) => {
      this.isVideoStreamingSupported = status.isStreamingRC;
    });

    this.remoteControlService.RemoteControlEmbedFinished.subscribe((status: RemoteControlEventArgs) => {
      this.isVideoStreamingSupported = status.isStreamingRC;
    });

    this.multiScreenSub = this.remoteControlService.deviceDualScreenConfigured.subscribe(
      (event: DualScreenConfiguredEventArgs) => {
        this.supportsDualScreen = event.shouldSupportDualScreen;
      }
    );
  }

  ngAfterViewInit(): void {}

  public getPopupTrigger = (): SotiPopupTrigger => this.multiDisplayPopupTrigger;
  //public displayOptions = ['Primary (800 x 480)', 'Secondary (1920 x 1080)'];
  public activeDisplay: IMonitorInfo;
  public availableDisplays: IMonitorInfo[] = [];

  /** checks if multiple displays are available */
  public get isMultiDisplayAvailable() {
    return this.supportsDualScreen && RcContext.instance.multiScreen.monitorList.length > 1 && !this.rcHasError();
  }

  /** checks if monitor list has virtual and provided border information inside */
  public get isLatestWindowsModernAgent() {
    return RcContext.instance.multiScreen.supportWinMonitorList;
  }

  public get deviceContext() {
    return <DeviceContext>RcContext.instance.deviceContext;
  }

  /** Fetch all the available displays  */
  public fetchAvailableDisplays() {
    this.availableDisplays = RcContext.instance.multiScreen.monitorList;

    const displayNames = [
      this.saI18nPipe.transform('remoteControl_MultiScreen_Virtual'),
      this.saI18nPipe.transform('remoteControl_MultiScreen_Primary'),
      this.saI18nPipe.transform('remoteControl_MultiScreen_Secondary'),
      this.saI18nPipe.transform('remoteControl_MultiScreen_All'),
    ];

    if (!RcContext.instance.multiScreen.supportWinMonitorList) {
      // Windows Classic or Android
      if (this.availableDisplays.length === displayNames.length) {
        for (let i = 0; i < displayNames.length; i++) {
          this.availableDisplays[i].name = displayNames[i];
        }
      } else {
        this.availableDisplays.forEach(a => {
          a.name = a.id !== 0 ? displayNames[2] : displayNames[1];
        });
      }
    } else {
      // TODO UI Change: Windows Modern
      this.availableDisplays[0].name = this.saI18nPipe.transform('remoteControl_MultiScreen_Virtual');
      for (let i = 1; i < this.availableDisplays.length; i++) {
        this.availableDisplays[i].name = this.saI18nPipe.transform('remoteControl_MultiScreen_Monitor') + " " + i;
      }
    }

    // also set the default display, if multiple are available
    if (this.availableDisplays.length > 0) {
      const monitorId = RcContext.instance.multiScreen.requestMonitorId;
      this.activeDisplay = this.availableDisplays.find(d => d.id === monitorId);
    }

    this.dualScreenPopupOpened = true;
  }

  /** Clear the collection on popup close  */
  public clearDisplays = () => {
    this.availableDisplays = [];
    this.activeDisplay = null;
    this.dualScreenPopupOpened = false;
  };

  public displaySelected = (display: IMonitorInfo, force: boolean = false) => {
    // const message = 'Change to screen ' + display.id;
    // const videoStreaming = document.getElementById('videoOuter') != null;

    // Only request PC_GETSYSINFO for the old windows agent
    if (this.availableDisplays.length > 1 && !RcContext.instance.multiScreen.supportWinMonitorList) {
      const deviceFamily = this.getDevice()?.family;
      const isWindowsDesktop =
        deviceFamily.indexOf(DEVICE_OS_FAMILY.WindowsCE) >= 0 ||
        deviceFamily.indexOf(DEVICE_OS_FAMILY.WindowsDesktop) >= 0;
      if (isWindowsDesktop && !this.windowsDisplayChangedSub) {
        this.windowsDisplayChangedSub = RcContext.instance.multiScreen.remoteControlDisplayChanged$.subscribe(
          (display: number) => {
            this.windowsDisplayChangedSub.unsubscribe();
            this.windowsDisplayChangedSub = undefined;
            // ask for the PC_SYSINFO
            this.refreshLegacyDeviceInfo();
          }
        );
      }
    }
    RcContext.instance.multiScreen.selectDeviceDisplayById(display.id, force);
  };

  // update z-index when in the screen-selection mode
  private preivousOuterZIndex;

  public get inVisualSelectionMode() {
    return RcContext.instance.multiScreen.inVisualSelectionMode;
  }

  public get workPanelHeight() {
    const eles = document.getElementsByClassName('work-panel-wrapper');
    return eles?.length !== 0 ? eles[0].clientHeight : 0;
  }

  public get workPanelBarContainerHeight() {
    const ele = document.querySelector<HTMLElement>('.work-panel-bars-container');
    let ret = ele ? ele.clientHeight + ele.offsetTop : this.workPanelHeight;
    return ret;
  }

  public updateCanvasZIndex = (inVisualSelection: boolean) => {
    const outer = document.getElementById('canvasOuter');
    if (inVisualSelection) {
      this.preivousOuterZIndex = outer.style.zIndex;
      outer.style.zIndex = '10';
    } else {
      outer.style.zIndex = this.preivousOuterZIndex ? this.preivousOuterZIndex : 1;
    }
  }

  public showVisualSelection = (info: VisualSelectionInfo) => {
    if (this.isActiveRecording) {
      return;
    }
    this.fetchAvailableDisplays();
    if (this.availableDisplays.length > 0) {
      if (info.inVisualMode) {
        RcContext.instance.multiScreen.savedMonitor = RcContext.instance.multiScreen.requestMonitorId;
      }

      const deviceScreenTransformService = RcContext.instance.deviceScreenTransformService;
      deviceScreenTransformService?.setTargetScale(DeviceScale.ScaleAuto);
      deviceScreenTransformService?.setCustomScale(deviceScreenTransformService.getAutoZoomScale());
      RcContext.instance.multiScreen.inVisualSelectionMode = info.inVisualMode;
      this.displaySelected(info.monitorInfo ? info.monitorInfo : this.availableDisplays[0], true);
      this.updateCanvasZIndex(this.inVisualSelectionMode);
      this.globalEventBusService.broadcast(GlobalEvents.remoteControlMultiScreenVisualSelection, this.inVisualSelectionMode);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.rcState && !this.rcState.firstScreenLoaded) {
      // This could happen if the rcFirstScreenLoaded was fired while not in active view.
      this.rcFirstScreenLoaded();
    }
    this.canvasFillComplete();

    if (changes.rcState && this.rcState && this.rcState.device) {
      this.tabSelectorState = this.remoteControlTabService.getState(this.rcState.device.deviceId);

      this.selectTab(this.tabSelectorState.selectedTab);
    }

    this.menuBarItems.emit(this.rcMenuBarItems);

    if (this.tabSelectorState && this.tabSelectorState.selectedTab === RcTabIndexes.legacyDeviceInfo) {
      this.actionBarRefEvent.emit(this.actionBarLegacyDeviceInfoRef);
    } else {
      this.actionBarRefEvent.emit(this.actionBarRef);
    }

    if (this.isCurrentWorkPanelRC()) {
      this.titleBarRefEvent.emit(this.titleBar);
    }

    if (this.getDeviceId() != null) {
      this.deviceStateRegistry.setRemoteControlErrorCallback(this.onRcError, this.getDeviceId());
    }
  }

  ngOnDestroy(): void {
    if (this.deviceLogRequestStatusChangedBroadcast) {
      this.deviceLogRequestStatusChangedBroadcast.close();
    }

    if (this.videoRecordingStatusChanged) {
      this.videoRecordingStatusChanged.close();
    }

    if (this.annotationStatusChanged) {
      this.annotationStatusChanged.close();
    }

    if (this.nonSnapshotTabSelected) {
      this.nonSnapshotTabSelected.close();
    }

    if (this.popoutRemoteControlStart) {
      this.popoutRemoteControlStart.close();
    }

    if (this.headertokenSub) {
      this.headertokenSub.unsubscribe();
    }

    if (this.openRcWorkPanelSub) {
      this.openRcWorkPanelSub.unsubscribe();
    }

    if (this.openLiveSnapshotSub) {
      this.openLiveSnapshotSub.unsubscribe();
    }

    this.multiScreenSub.unsubscribe();

    if (this.windowsDisplayChangedSub) {
      this.windowsDisplayChangedSub.unsubscribe();
    }
  }

  public setToast(toast: Toast) {
    this.setToastEvent.emit(toast);
  }

  private isDeviceLogAvailable = (): boolean =>
    this.remoteControlSessionService.isDeviceLogSupported && this.isAdminOrTechnician();

  public isTaskManagerAvailable = (): boolean => {
    let result = false;
    result =
      (this.isAndroidDevice() || this.isWindowsDevice()) &&
      this.hasTaskManagerPermissions() &&
      this.isLicenceActive &&
      this.isAdminOrTechnician();

    return result;
  };

  /** Determines if the current RC session supports input (as opposed to being view-only) */
  public supportsInput = () => {
    if (this.isRcConnected()) {
      const result =
        this.deviceStateRegistry.hasPermission(this.rcState, hd.RemoteControlPermissions.RemoteControlInput) &&
        !this.deviceStateRegistry.isRemoteViewOnly(this.rcState.device);
      return result;
    }
    return false;
  };

  public setRcCanvasReady = () => {
    this.remoteControlService.setRcCanvasReady();
  };

  public showRcActionbar = (): boolean => this.isTabSelected(RcTabIndexes.remoteControl) && !this.rcHasError();

  public showLegacyDeviceInfoActionBar = (): boolean => this.isTabSelected(RcTabIndexes.legacyDeviceInfo);

  public refreshLegacyDeviceInfo = () => {
    RcContext.instance.session.sendCallbackRequest(new GetSysInfoMessage());
  };

  public toggleShowDeviceButtons = (showDeviceButtons: boolean): void => {
    setTimeout(() => {
      this._showDeviceButtonsToggle = showDeviceButtons;
    });
  };

  public toggleShowFileManagerButtons = (showFileManagerButtons: boolean): void => {
    this.showFileManagerButtonsToggle = showFileManagerButtons;
  };

  public showDeviceButtons = (): boolean =>
    this._showDeviceButtonsToggle &&
    this.rcState &&
    this.isTabSelected(RcTabIndexes.remoteControl) &&
    !this.deviceStateRegistry.isRemoteViewOnly(this.rcState.device) &&
    !this.rcHasError();

  public showFileManagerButtons = (): boolean =>
    ((this.isAndroidDevice() ||
      this.isWindowsDevice() ||
      this.tunnelService.isLinuxDevice(this.rcState) ||
      this.isAppleDevice()) &&
      this.isRcConnected() &&
      this.isTabSelected(RcTabIndexes.fileExplorer) &&
      !this.rcHasError()) === true;

  public getCurrentRcPanelTitle = (): string => {
    if (this.tabSelectorState) {
      const rcMenuBarItem = this.getRcMenuBarItemByTabIndex(this.tabSelectorState.selectedTab);
      if (rcMenuBarItem) {
        this._currentTabTitle = rcMenuBarItem.tooltip();
      }
    }

    return this._currentTabTitle;
  };

  public getDevice = (): hd.IDeviceModel => {
    if (this.rcState && this.rcState.device) {
      return this.rcState.device;
    }
    return null;
  };

  public getDeviceId = (): string => {
    if (this.rcState && this.rcState.device) {
      return this.rcState.device.deviceId;
    }
    return null;
  };

  public isStandaloneRC = (): boolean => {
    if (this.rcState) {
      return this.standAlone && this.rcState && !this.rcState.poppedOut;
    }
    return this.standAlone;
  };

  public rcHasError = (): boolean => {
    if (this.rcState && this.rcState.hasError) {
      return true;
    }
    return false;
  };

  public showConnectionScreen = (): boolean => {
    // If in RC tab show either screen (user needs permission or connecting)
    const showConnectionScreen = !this.rcHasError() && this.isRcConnecting;
    if (this.isTabSelected(RcTabIndexes.remoteControl)) {
      return showConnectionScreen;
    }

    // If not RC tab, show only if the user needs to accept prompt
    return showConnectionScreen && !this.canRcWithoutNotification;
  };

  public tabViewVisible = (): boolean => !this.rcHasError();

  public showRightMargin = (): boolean =>
    this.isTabSelected(RcTabIndexes.fileExplorer) || this.isTabSelected(RcTabIndexes.taskManager);

  public toggleAnnotations() {
    if (!this.isAnnotationAllowed) {
      return;
    }
    if (this.rcAnnotationService.currentState.isAnnotating) {
      this.rcAnnotationService.stopAnnotations();
      // TODO: perhaps need to invoke changeDetectorRef.detectChanges()
      // in then(...) if Angular does not detect annotations active and updates
      // button on this toolbar
    } else {
      this.rcAnnotationService.startAnnotations();
      // TODO: perhaps need to invoke changeDetectorRef.detectChanges()
      // in then(...) if Angular does not detect annotations active and updates
      // button on this toolbar
    }
  }

  public restartRc = event => {
    if (this.rcState && this.rcState.hasError && this.rcState.device) {
      RcContext.instance.forceOverride = event && event.ctrlKey;

      if (this.popOut) {
        this.globalEventBusService.broadcast(GlobalEvents.startRemoteControlFromPopOut, this.rcState.device);
      } else if (this.isStandaloneRC()) {
        this.globalEventBusService.broadcast(GlobalEvents.startRemoteControlFromStandaloneRC, this.rcState.device);
      } else {
        this.globalEventBusService.broadcast(GlobalEvents.startRemoteControl, this.rcState.device);
      }
    } else {
      console.error('restarting remote control error');
    }
  };

  public getErrorMessage = (): string => {
    if (this.rcHasError()) {
      if (this.rcState.errorMessage) {
        return this.rcState.errorMessage;
      } else {
        return this.saI18nPipe.transform('remoteControl_UnknownErrorOccurred');
      }
    }
    return null;
  };

  public getErrorMessageDescription = (): string => {
    if (this.rcHasError()) {
      if (this.rcState.errorMessageDescription) {
        return this.rcState.errorMessageDescription;
      } else if (this.rcState.errorMessage) {
        return this.rcState.errorMessage;
      } else {
        return this.saI18nPipe.transform('remoteControl_UnknownErrorOccurred');
      }
    }
    return null;
  };

  public getErrorMessageCaption = (): string => {
    if (this.rcHasError()) {
      if (this.rcState.errorMessageCaption) {
        return this.saI18nPipe.transform('remoteControl_User_Logged_Out_Message_Caption');
      } else {
        return this.saI18nPipe.transform('ticket_RemoteControl_ConnectionLost');
      }
    }
    return null;
  };

  public isRecording = () => {
    if (this.rcState) {
      return this.rcState.recording;
    } else {
      return false;
    }
  };

  public allowServerSideRecording = (): boolean =>
    !this.isRecording() && this.isLicenceActive && this.isAdminOrTechnician();

  public isClientSideRotationEnabled = (): boolean =>
    this.rcState &&
    this.rcState.device &&
    this.rcState.device.kind !== 'WindowsDesktopLegacy' &&
    this.rcState.device.kind !== 'WindowsDesktop' &&
    this.rcState.device.kind !== 'Linux' &&
    this.rcState.device.kind !== 'Mac' &&
    !this.remoteControlService.isVideoStreaming(this.rcState.mcDeviceId);

  public isScreenSettingsVisible = (): boolean => !this.isRecording() && !this.isVideoStreamingSupported;

  public isFileExplorerAvailable = (): boolean =>
    this.deviceStateRegistry.hasPermission(this.rcState, hd.RemoteControlPermissions.RemoteControlViewFiles) &&
    (this.isRcConnected() || this.rcHasError()) &&
    !this.showConnectionScreen();

  private hasTaskManagerPermissions = () =>
    this.deviceStateRegistry.hasPermission(this.rcState, hd.RemoteControlPermissions.RemoteControlViewTasks) &&
    (this.isRcConnected() || this.rcHasError()) &&
    !this.showConnectionScreen();

  private rcFirstScreenLoaded() {
    if (this.rcState) {
      this.remoteControlService.setCanvasOuterHeight();
      this.rcState.firstScreenLoaded = true;
    }
  }

  private isRcConnected = (): boolean => this.rcState && this.rcState.connected;

  private tabButtonClicked = (tabIndex: number) => {
    const currentWorkPanelDevice = this.workPanelManagerService.getPanelDevice(this.currentWorkPanelKey);
    if (!currentWorkPanelDevice) {
      console.error('rc clicked but no device specified');
      return;
    }

    if (tabIndex === RcTabIndexes.remoteControl && !this.isRcConnected() && !this.rcHasError()) {
      // if the remote control button on the menu bar is clicked but rc not started, we will try to start rc
      if (this.workPanelManagerService.isPanelTypePoppedOut(WorkPanelType.liveSnapshot)) {
        this.globalEventBusService.broadcast(GlobalEvents.startRemoteControlFromPopOut, currentWorkPanelDevice);
      } else if (this.workPanelManagerService.isPanelTypeEmbedded(WorkPanelType.liveSnapshot)) {
        this.globalEventBusService.broadcast(GlobalEvents.startRemoteControl, currentWorkPanelDevice);
      }
    }

    if (!this.isCurrentWorkPanelRC()) {
      // if one of the rc tab buttons(rc, file explorer, task manager) is clicked but currently not in RC view, then open rc view in work panel
      this.globalEventBusService.broadcast(GlobalEvents.openRcWorkPanel, {
        device: currentWorkPanelDevice,
        workPanelKey: null,
      } as IWorkPanelInformation);
    }

    if (tabIndex === RcTabIndexes.snapshot) {
      const snapshotInfo: ISnapshotInformation = {
        device: currentWorkPanelDevice,
        mcConnectionName: currentWorkPanelDevice.$$mcConnectionName,
        snapshotActivity: null,
        workPanelKey: this.currentWorkPanelKey,
      };
      this.globalEventBusService.broadcast(GlobalEvents.openLiveSnapshot, snapshotInfo);
    }

    this.selectTab(tabIndex);

    if (tabIndex === RcTabIndexes.legacyDeviceInfo) {
      this.actionBarRefEvent.emit(this.actionBarLegacyDeviceInfoRef);
    }

    if (tabIndex === RcTabIndexes.remoteControl || tabIndex === RcTabIndexes.fileExplorer) {
      this.actionBarRefEvent.emit(this.actionBarRef);
    }

    if (this.isCurrentWorkPanelRC()) {
      this.titleBarRefEvent.emit(this.titleBar);
    }
  };

  private selectTab = (tabIndex: number) => {
    // if tabIndex is null or undefined, which means it's not a tab, just an action button
    if (!this.tabSelectorState || tabIndex == null) {
      return;
    }

    if (tabIndex === RcTabIndexes.snapshot) {
      if (!this.snapshotService.isPlatformSupported(this.rcState?.device?.family)) {
        tabIndex = RcTabIndexes.legacyDeviceInfo;
      }
    } else {
      this.nonSnapshotTabSelected.postMessage(null);
    }

    this.tabSelectorState.select(tabIndex);

    this.updateTransformationHandler(tabIndex);
  };

  private updateTransformationHandler = (tabIndex: number): void => {
    setTimeout(() => {
      if (tabIndex === RcTabIndexes.remoteControl) {
        const deviceContextHandler = RcContext.instance.deviceContextHandler;
        if (deviceContextHandler) {
          deviceContextHandler.contextReady$
            .pipe(first(isReady => isReady === true)) // receives only the first message and automatically unsubscribe once received
            .subscribe(() => RcContext.instance.deviceScreenTransformService?.updateTransform());

          this.globalEventBusService.broadcast(GlobalEvents.remoteControlTabSelected, tabIndex);
        }
      }
    });
  };

  private getRcMenuBarItemByTabIndex = (tabIndex: number): WorkPanelBarItem => {
    if (!this.rcMenuBarItems) {
      this.buildRcMenuBarItems();
    }
    return this.rcMenuBarItems.find(item => item.tabIndex === tabIndex);
  };

  private isTabSelected = (tabIndex?: number): boolean => {
    if (!this.isCurrentWorkPanelRC()) {
      return false;
    }

    // if tabIndex is null or undefined, which means it's not a tab, just an action button
    if (!this.tabSelectorState || tabIndex == null) {
      return false;
    }
    return this.tabSelectorState.selectedTab === tabIndex;
  };

  private isTabDisabled = (tabIndex?: number): boolean => false;

  private isAppleDevice = (): boolean => {
    return this.deviceService.isSpecificDeviceFamily(this.rcState, [DEVICE_OS_FAMILY.Apple]);
  };

  private isWindowsDevice = (): boolean => {
    return this.deviceService.isSpecificDeviceFamily(this.rcState, [
      DEVICE_OS_FAMILY.WindowsCE,
      DEVICE_OS_FAMILY.WindowsDesktop,
      DEVICE_OS_FAMILY.WindowsModernDesktop,
      DEVICE_OS_FAMILY.WindowsPhone,
    ]);
  };

  private isAndroidDevice = (): boolean => {
    return this.deviceService.isSpecificDeviceFamily(this.rcState, [
      DEVICE_OS_FAMILY.Android,
      DEVICE_OS_FAMILY.AndroidPlus,
    ]);
  };

  private handleAnnotationStatus = (status: AnnotationStatus) => {
    this.setToast({
      message: this.saI18nPipe.transform('annotations_Cancelled_Message'),
      type: ToastTypeIndex.error,
    } as Toast);
  };

  private handleDeviceLogsDownloadStatusChange = (statusChange: IDeviceLogRequestStatusChange): void => {
    if (
      statusChange.previous === DeviceLogRequestStatus.None &&
      statusChange.current === DeviceLogRequestStatus.Pending
    ) {
      // Download just started
      this.setToast({
        message: this.saI18nPipe.transform('ticket_RemoteControlTabs_DeviceLogsDownloadStarted'),
        type: ToastTypeIndex.info,
      } as Toast);
    } else if (
      statusChange.previous === DeviceLogRequestStatus.Attaching &&
      statusChange.current === DeviceLogRequestStatus.None
    ) {
      // Download finished successfully
      this.setToast({
        message: this.saI18nPipe.transform('ticket_RemoteControlTabs_DeviceLogsDownloadSuccessfull'),
        type: ToastTypeIndex.success,
      } as Toast);
    } else if (
      statusChange.previous === DeviceLogRequestStatus.Delayed &&
      statusChange.current === DeviceLogRequestStatus.None
    ) {
      // Download finished because user cancelled
      this.setToast({
        message: this.saI18nPipe.transform('ticket_RemoteControlTabs_DeviceLogsDownloadCanceled'),
        type: ToastTypeIndex.info,
      } as Toast);
    } else if (statusChange.current === DeviceLogRequestStatus.Error) {
      const messageLabel = statusChange.message
        ? statusChange.message
        : 'ticket_RemoteControlTabs_DeviceLogsDownloadError';
      // Download finished because of an error
      this.setToast({ message: this.saI18nPipe.transform(messageLabel), type: ToastTypeIndex.error } as Toast);
      // Clean the error flag, so the user can restart downloading the device logs
      this.rcLogsService.setDeviceLogRequestStatus(DeviceLogRequestStatus.None);
    }
  };

  private handleRecordingStatus = (status: VideoRecordingStatus) => {
    // If statements indicate priority of the messages
    if (status.serverStatusCode) {
      this.setToast({
        message: this.remoteControlSessionService.mapServerStatusMessage(status.serverStatusCode),
        type: ToastTypeIndex.error,
      });
    } else if (status.recordingWithAudioStopReason) {
      this.setToast({
        message: this.videoRecordingService.mapAgentRecordingStopReasonMessage(status.recordingWithAudioStopReason),
        type: ToastTypeIndex.error,
      });
    } else if (status.win32ErrorCode) {
      this.setToast({ message: getWin32ErrorMessage(status.win32ErrorCode), type: ToastTypeIndex.error });
    } else if (status.state === RecordingState.UploadingVideo || status.state === RecordingState.TranscodingVideo) {
      this.setToast({ message: this.saI18nPipe.transform('videoRecording_Popover_Title'), type: ToastTypeIndex.info });
    }
  };

  private onRcError = () => {
    if (this.rcHasError()) {
      this.setToast({
        message: this.getErrorMessage(),
        type: ToastTypeIndex.error,
      } as Toast);
    }
  };

  private isCurrentWorkPanelRC = (): boolean =>
    this.workPanelManagerService.getPanelType(this.currentWorkPanelKey) === WorkPanelType.rc;

  private buildRcMenuBarItems = () => {
    // Order shall never change! always append to the list
    this.rcMenuBarItems = [
      {
        name: 'rc',
        tooltip: () => this.workPanelService.getRCToolTip(this.rcState, this.currentWorkPanelKey),
        onClick: this.tabButtonClicked,
        icon: () => 'hd-icon-cast',
        isVisible: () => this.workPanelService.isRCAvailable(this.currentWorkPanelKey),
        tabIndex: RcTabIndexes.remoteControl,
        selected: this.isTabSelected,
        isDisabled: () => this.workPanelService.isRcDisabled(this.currentWorkPanelKey),
      },
      {
        name: 'download device logs',
        tooltip: this.rcLogsService.getDownloadLogButtonTooltip,
        onClick: () => {},
        icon: this.rcLogsService.getDownloadDeviceLogsIcon,
        isVisible: this.isDeviceLogAvailable,
        selected: () => false,
        spinning: this.rcLogsService.isDownloadLogsButtonSpinning,
        cssClass: this.rcLogsService.getDownloadLogButtoncssClass,
        isDisabled: () => this.isTabDisabled() || this.fileManagerService.fileTransferInProgress(),
      },
      {
        name: 'file explorer',
        tooltip: () => this.saI18nPipe.transform('ticket_RemoteControlTabs_FileExplorer'),
        onClick: this.tabButtonClicked,
        icon: () => 'hd-icon-folder',
        isVisible: this.isFileExplorerAvailable,
        tabIndex: RcTabIndexes.fileExplorer,
        selected: this.isTabSelected,
        isDisabled: this.isTabDisabled,
      },
      {
        name: 'task mananger',
        tooltip: () => this.saI18nPipe.transform('ticket_RemoteControlTabs_TaskManager'),
        onClick: this.tabButtonClicked,
        icon: () => 'hd-icon-taskmanager',
        isVisible: this.isTaskManagerAvailable,
        tabIndex: RcTabIndexes.taskManager,
        selected: this.isTabSelected,
        isDisabled: this.isTabDisabled,
      },
      {
        name: 'web console',
        tooltip: () => this.saI18nPipe.transform('ticket_RemoteControlTabs_WebConsole'),
        onClick: () => (this.headertokenSub = this.tunnelService.popOutWebConsole(this.rcState)),
        icon: () => 'hd-icon-webconsole',
        selected: this.isTabSelected,
        isVisible: () => this.tunnelService.allowRemoteControlWebConsole(this.rcState),
        tabIndex: RcTabIndexes.webConsole,
        isDisabled: this.isTabDisabled,
      },
      {
        name: 'terminal',
        tooltip: () => this.saI18nPipe.transform('ticket_RemoteControlTabs_Terminal'),
        onClick: () => (this.headertokenSub = this.tunnelService.popOutTerminal(this.rcState)),
        icon: () => 'hd-icon-terminal',
        isVisible: () => this.tunnelService.allowRemoteControlTerminal(this.rcState),
        selected: this.isTabSelected,
        tabIndex: RcTabIndexes.terminal,
        isDisabled: this.isTabDisabled,
      },
    ];
  };

  private canvasFillComplete = () => {
    const deviceContextHandler = RcContext.instance.deviceContextHandler;
    if (deviceContextHandler) {
      deviceContextHandler.contextReady$
        .pipe(first(isReady => isReady === true)) // receives only the first message and automatically unsubscribe once received
        .subscribe(() => RcContext.instance.deviceScreenTransformService?.makeCanvasVisible());
    }
  };

  private isAdminOrTechnician(): boolean {
    return (
      (this.standAlone && this.authorizationService.isAnyGroupAdminOrTechnician()) ||
      this.authorizationService.isAdminOrTechnician(this.groupContextService.currentGroupId)
    );
  }

  public isVideoStreamingSupported: boolean = true;

  public showCanvas() {
    if (this.isVideoStreamingSupported === undefined) {
      return;
    }

    let clientWidth: number;
    let clientHeight: number;
    if (this.isVideoStreamingSupported) {
      clientWidth = this.videoOuter.nativeElement.clientWidth;
      clientHeight = this.videoOuter.nativeElement.clientHeight;
    } else {
      if (!this.canvasComponent) {
        return;
      }

      this.canvasComponent.showComponent();
      clientWidth = this.canvasOuter.nativeElement.clientWidth;
      clientHeight = this.canvasOuter.nativeElement.clientHeight;
    }

    const deviceContextHandler = RcContext.instance.deviceContextHandler;
    if (deviceContextHandler) {
      deviceContextHandler.updateWithCanvasChanges(clientWidth, clientHeight);
    }
  }

  public hideCanvas() {
    if (this.canvasComponent) {
      this.canvasComponent.hideComponent();
    }
  }

  public get isRcConnecting(): boolean {
    if (!this.rcState?.active) {
      return false;
    }
    if (!this.rcState.connected || this.isVideoStreamingSupported === undefined) {
      return true;
    }
    return !this.deviceStateRegistry.isCurrentRemoteControlRunning();
  }

  public get canRcWithoutNotification(): boolean {
    const can = this.deviceStateRegistry.hasPermission(
      this.rcState,
      hd.RemoteControlPermissions.RemoteControlWithoutNotification
    );
    return can || this.deviceStateRegistry.isCurrentRemoteControlRunning();
  }

  public get isActiveRecording(): boolean {
    return (
      this.rcState &&
      this.rcState.device &&
      (this.deviceStateRegistry.isRecording(this.rcState.device) || this.deviceStateRegistry.isRecordingPendingAccept())
    );
  }

  /** Used to show the appropriate flavour of the connecting screen: Waiting for User Permissions screen should be shown
   * only after the permissions have been received */
  public get knowsPermissions(): boolean {
    return !!this.rcState?.device?.deviceId && this.deviceStateRegistry.knowsPermissions(this.rcState.device.deviceId);
  }
}
